import {Configuration} from './generated';
// registers the interceptor which creates the XSRF cookie again if it was deleted
import "components/src/auth/Xsrf";

const config = new Configuration()

const baseURL = import.meta.env.VITE_API_URL;

export const ApiConfig = () => {
    return
}

function getApiConfig() {
    config.basePath = baseURL
    return config;
}

ApiConfig.config = getApiConfig;